import {
	ACCESS_POINT_RADIO_SETTING_DATA_RESPONSE_GET_FAIL,
	ACCESS_POINT_RADIO_SETTING_DATA_RESPONSE_GET_SUCCESS,
	ACCESS_POINT_RADIO_SETTING_API_LOADING,
	GET_DEVICE_MODEL,
	GET_DEVICE_MODEL_FAIL,
	GET_DEVICE_MODEL_RESET,
	GET_DEVICE_MODEL_SUCCESS,
	OFFLINE_AP_INDICATION,
	RADIO_SETTING_ATCP_RESPONSE_GET_FAIL,
	RADIO_SETTING_ATCP_RESPONSE_GET_SUCCESS,
	RADIO_SETTING_DATA_RESPONSE_GET_FAIL,
	RADIO_SETTING_DATA_RESPONSE_GET_SUCCESS,
	RADIO_SETTING_REQUEST_GET,
	RADIO_SETTING_RESPONSE_GET_FAIL,
	RADIO_SETTING_RESPONSE_GET_SUCCESS,
	RADIO_SETTING_WIPS_RESPONSE_GET_FAIL,
	RADIO_SETTING_WIPS_RESPONSE_GET_SUCCESS,
	TIP_RADIO_GET_ERROR,
	TIP_RADIO_GET_SUCCESS,
	TIP_RADIO_UPDATE_ERROR,
	TIP_RADIO_UPDATE_SUCCESS,
} from '../constants/radioSettingConstants';

export const radioSettingListReducer = (
	state = { radioSetting: {}, offlineIndication: false },
	action
) => {
	switch (action.type) {
		case RADIO_SETTING_REQUEST_GET:
			return {
				...state,
				loading: true,
				radioSetting: {},
			};
		case RADIO_SETTING_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				radioSetting: action.payload,
			};
		case RADIO_SETTING_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
				radioSetting: {},
			};
		case OFFLINE_AP_INDICATION:
			return {
				...state,
				offlineIndication: action.payload,
			};
		default:
			return state;
	}
};

export const tipRadioReducer = (
	state = {
		tipRadioData: {},
		tipRadioError: null,
		updateTipError: null,
		updateTipSuccess: null,
	},
	action
) => {
	switch (action.type) {
		case TIP_RADIO_GET_SUCCESS:
			return {
				...state,
				tipRadioData: action.payload,
			};
		case TIP_RADIO_GET_ERROR:
			return {
				...state,
				tipRadioError: action.payload,
			};
		case TIP_RADIO_UPDATE_SUCCESS:
			return {
				...state,
				updateTipError: null,
				updateTipSuccess: action.payload,
			};
		case TIP_RADIO_UPDATE_ERROR:
			return {
				...state,
				updateTipError: action.payload,
				updateTipSuccess: null,
			};

		default:
			return state;
	}
};

export const radioSettingDataReducer = (
	state = { radioSettingData: {}, radioSettingDataError: {} },
	action
) => {
	switch (action.type) {
		case RADIO_SETTING_DATA_RESPONSE_GET_SUCCESS:
			return {
				...state,
				radioSettingData: action.payload,
			};
		case RADIO_SETTING_DATA_RESPONSE_GET_FAIL:
			return {
				...state,
				radioSettingDataError: action.payload,
			};

		default:
			return state;
	}
};

export const radioSettingAtcpReducer = (
	state = { radioSettingAtcp: {}, radioSettingAtcpError: {} },
	action
) => {
	switch (action.type) {
		case RADIO_SETTING_ATCP_RESPONSE_GET_SUCCESS:
			return {
				...state,
				radioSettingAtcp: action.payload,
			};
		case RADIO_SETTING_ATCP_RESPONSE_GET_FAIL:
			return {
				...state,
				radioSettingAtcpError: action.payload,
			};

		default:
			return state;
	}
};

export const radioSettingWipsReducer = (
	state = { radioSettingWips: {}, radioSettingWipsError: {} },
	action
) => {
	switch (action.type) {
		case RADIO_SETTING_WIPS_RESPONSE_GET_SUCCESS:
			return {
				...state,
				radioSettingWips: action.payload,
			};
		case RADIO_SETTING_WIPS_RESPONSE_GET_FAIL:
			return {
				...state,
				radioSettingAtcpWips: action.payload,
			};

		default:
			return state;
	}
};

export const accessPointRadioSettingDataReducer = (
	state = {
		accessPonintRadioSettingData: {},
		acessPointRadioSettingDataError: {},
		accessPointRadioSettingApiLoading : false
	},
	action
) => {
	switch (action.type) {
		case ACCESS_POINT_RADIO_SETTING_API_LOADING:
			return {
				...state,
				accessPonintRadioSettingData: {},
				accessPointRadioSettingApiLoading : true,
			};
		case ACCESS_POINT_RADIO_SETTING_DATA_RESPONSE_GET_SUCCESS:
			return {
				...state,
				accessPonintRadioSettingData: action.payload,
				accessPointRadioSettingApiLoading : false,
			};
		case ACCESS_POINT_RADIO_SETTING_DATA_RESPONSE_GET_FAIL:
			return {
				...state,
				acessPointRadioSettingDataError: action.payload,
				accessPointRadioSettingApiLoading : false,
			};

		default:
			return state;
	}
};

export const getDeviceModelsReducer = (
	state = { deviceModels: {} },
	action
) => {
	switch (action.type) {
		case GET_DEVICE_MODEL:
			return {
				...state,
				deviceModels: {},
			};
		case GET_DEVICE_MODEL_SUCCESS:
			return {
				...state,
				deviceModels: action.payload,
			};
		case GET_DEVICE_MODEL_FAIL:
			return {
				...state,
				deviceModels: {},
			};
		case GET_DEVICE_MODEL_RESET:
			return {
				...state,
				deviceModels: {},
			};

		default:
			return state;
	}
};
